import { Log } from '@scayle/storefront-nuxt'
import * as Sentry from '@sentry/nuxt'
import { defineNuxtPlugin } from '#app/nuxt'
import useAgsLog from '~/composables/useAgsLog'

export default defineNuxtPlugin((nuxtApp) => {
  Log.default = useAgsLog(undefined, Sentry)
  Log.default.info('Log initialized')

  nuxtApp.hook('vue:error', (error: any) => {
    if (error?.statusCode === 404 || error?.statusCode === 422) return
    useAgsLog('vue:error').error(error)
  })

  nuxtApp.vueApp.config.errorHandler = (error: any, vm, info) => {
    Log.default.error(error, { vm, info })
  }

  nuxtApp.vueApp.config.warnHandler = (msg, vm, trace) => {
    Log.default.warn(msg, { vm, trace })
  }

  return {
    // PLEASE NOTE: Can't provide a log yet, since SFC prevents it... waiting for sfc update
    // provide: { log: Log.default },
  }
})
